import { createContext, useContext, useEffect } from "react";

import axios from "../../axios";
import { errorToast } from "../../utils/toast";
import { useUser } from "../../hooks/use-user";

import { Riple } from "react-loading-indicators";

const AuthenticationContext = createContext(null);

const Authentication = ({ children }) => {
  const { data: authenticatedUser, isLoading, isError, error } = useUser();

  // -------------------------------------------------
  // 1️⃣ BROADCAST CHANNEL — Cross-tab Logout
  // -------------------------------------------------
  useEffect(() => {
    const bc = new BroadcastChannel("auth");

    bc.onmessage = (event) => {
      if (event.data === "logout") {
        localStorage.removeItem("token");
        window.location.href = "/login";
      }
    };

    return () => bc.close();
  }, []);

  // -------------------------------------------------
  // 2️⃣ Handle auth errors from useUser
  // -------------------------------------------------
  useEffect(() => {
    if (isError && error?.response?.status === 401) {
      localStorage.removeItem("token");
      const bc = new BroadcastChannel("auth");
      bc.postMessage("logout");
      window.location.href = "/login";
    } else if (isError) {
      errorToast(error?.response?.data?.Comments || "Something went wrong");
    }
  }, [isError, error]);

  if (isLoading) return <Riple color="#000000" size="medium" text="" textColor="" />;

  return (
    <AuthenticationContext.Provider value={authenticatedUser}>
      {children}
    </AuthenticationContext.Provider>
  );
};

export const useAuth = () => useContext(AuthenticationContext);

export default Authentication;
